enum Routes {
  // account
  LANDING = '/landing',
  SIGNIN = '/landing/signin',
  ADMIN_SIGN_IN = '/admin/sudo-signin',
  SIGNUP = '/landing/signup',
  SIGNUP_SUCCESS = '/landing/signup/success',
  FORGET_PASSWORD = '/landing/forget',
  RESET_PASSWORD = '/landing/reset',
  // motivE
  SURVEY_OVERVIEW = '/products/survey-overview',
  SURVEY = '/survey',
  MOTIVE_WEB_REPORT = '/motive-report',

  // lead
  LEAD_CREATION = '/products/lead/creation',
  LEAD_CREATION_DETAILS = '/products/lead/creation/details',
  LEAD_QUESTIONNAIRE = '/products/lead/questionnaire',

  // OAuth
  OAUTH_GMAIL_SUCCESS = '/oauth/gmail/success',
  OAUTH_MICROSOFT_SUCCESS = '/oauth/microsoft/success',

  // administration
  ADMINISTRATION = '/administration',
  PROMPT_MANAGEMENT = '/administration/prompt-management',
  STATUS_MESSAGE_MANAGEMENT = '/administration/status-message-management',
  ADMIN_MONITORING = '/administration/monitoring',
  ADMIN_USER_OVERVIEW = '/administration/user-overview',
  ADMIN_QUEUE_MANAGEMENT = '/administration/queue-management',
  ADMIN_LINKEDIN_SESSION_MONITOR = '/administration/linkedin-session-monitor',
  ADMIN_CAMPAIGN_CONTACT_TIMELINE = '/administration/campaign-contact-timeline',
  ADMIN_FEEDBACK_TICKETS = '/administration/feedback-tickets',
  /** Engagement Center; tab as optional path segment (/administration/engagement/wachstum). */
  ADMIN_ENGAGEMENT = '/administration/engagement',
  /** A single feedback ticket, deep-linked from the notification mail. */
  FEEDBACK_TICKET = '/feedback/:id',

  // general
  FEATURE_OVERVIEW = '/feature-overview',
  UPGRADE = '/upgrade',
  ACCOUNT = '/account',
  /** Mitteilungen (bell) — not "Inbox": Posteingang means LinkedIn messages. */
  NOTIFICATIONS = '/notifications',

  // lead booster
  LEAD_BOOSTER = '/lead-booster',
  LEAD_BOOSTER_GENERATE_GLOBAL_PROFILE = '/lead-booster/text-generation/global-profile',
  LEAD_BOOSTER_GENERATE_TAILORED_PROFILE = '/lead-booster/text-generation/tailored-profile',
  LEAD_BOOSTER_OPTIMIZE = '/lead-booster/text-optimization',
  LEAD_BOOSTER_DONE = '/lead-booster/done',
  LEAD_BOOSTER_AUTO_FUNNEL = '/lead-booster/auto-funnel',
  LEAD_BOOSTER_CO_PILOT = '/lead-booster/co-pilot',
  LEAD_BOOSTER_CO_PILOT_PROJECTS = '/lead-booster/co-pilot/projects',
  LEAD_BOOSTER_CO_PILOT_CAMPAIGN = '/lead-booster/co-pilot/campaign',
  LEAD_BOOSTER_CO_PILOT_ACCOUNTS = '/lead-booster/co-pilot/accounts',
  LEAD_BOOSTER_CO_PILOT_BLACKLIST = '/lead-booster/co-pilot/blacklist',
  LEAD_BOOSTER_CO_PILOT_STATISTICS = '/lead-booster/co-pilot/statistics',
  LEAD_BOOSTER_CO_PILOT_INBOX = '/lead-booster/co-pilot/inbox',
  LEAD_BOOSTER_CO_PILOT_TASKS = '/lead-booster/co-pilot/tasks',

  // hr booster
  HR_BOOSTER = '/hr-booster',
  HR_BOOSTER_GENERATE_GLOBAL_PROFILE = '/hr-booster/text-generation/global-profile',
  HR_BOOSTER_GENERATE_TAILORED_PROFILE = '/hr-booster/text-generation/tailored-profile',
  HR_BOOSTER_OPTIMIZE = '/hr-booster/text-optimization',
  HR_BOOSTER_DONE = '/hr-booster/done',
  HR_BOOSTER_AUTO_FUNNEL = '/hr-booster/auto-funnel',
  RECRUITING_BOOSTER_CO_PILOT = '/recruiting-booster/co-pilot',
  RECRUITING_BOOSTER_CO_PILOT_PROJECTS = '/recruiting-booster/co-pilot/projects',
  RECRUITING_BOOSTER_CO_PILOT_CAMPAIGN = '/recruiting-booster/co-pilot/campaign',
  RECRUITING_BOOSTER_CO_PILOT_NEW_CAMPAIGN = '/recruiting-booster/co-pilot/new-campaign',
  RECRUITING_BOOSTER_CO_PILOT_ACCOUNTS = '/recruiting-booster/co-pilot/accounts',
  RECRUITING_BOOSTER_CO_PILOT_BLACKLIST = '/recruiting-booster/co-pilot/blacklist',
  RECRUITING_BOOSTER_CO_PILOT_STATISTICS = '/recruiting-booster/co-pilot/statistics',
  RECRUITING_BOOSTER_CO_PILOT_INBOX = '/recruiting-booster/co-pilot/inbox',
  RECRUITING_BOOSTER_CO_PILOT_TASKS = '/recruiting-booster/co-pilot/tasks',

  // misc
  PERSONA_GENERATOR = '/persona-generator',
  URL_FINDER = '/url-finder',
  MOTIVE_TESTS = '/motive-tests',
  INSTALL_EXTENSION_SUCCESS = '/extension/installation/success',
  WEBMETICS_OVERVIEW = '/webmetics',

  // external linkedin handling
  EXTERNAL_LINKEDIN_ACCOUNTS = '/external/linkedin-accounts',

  // external call Transcript handling
  EXTERNAL_CALL_TRANSCRIPTS = 'call-transcripts',

  // contact management
  CONTACT_MANAGEMENT = '/contact-management',
  CONTACT_MANAGEMENT_OVERVIEW = '/contact-management/overview',
  CONTACT_MANAGEMENT_CONTACT = '/contact-management/contact',
  CONTACT_MANAGEMENT_TAG_MANAGEMENT = '/contact-management/tag-management',
  CONTACT_MANAGEMENT_INTEGRATIONS = '/contact-management/integration',

  // Posting Creation
  POSTING_CREATION = '/posting-creation',
  POSTING_CREATION_OVERVIEW = '/posting-creation/overview',

  // Lead List Research Agent
  LEAD_LIST_RESEARCH = '/lead-list-research',

  // Lead List Storage
  LEAD_LIST_STORAGE = '/lead-list-storage',
  // Main Store / Use-Case-Store
  USE_CASE_STORE = '/use-case-store',

  // Pipeline board
  PIPELINE = '/pipeline',

  // AI Chat
  AI_CHAT = '/ai-chat',

  // Public Chat (landing page)
  PUBLIC_CHAT = '/welcome',
}

enum AWTypes {
  TALENT = 'talent',
  BRAND = 'brand',
  CUSTOMER = 'customer',
  BLOG = 'blog',
  ECOMMERCE = 'ecommerce',
  LINKEDIN_MSG = 'linkedin_msg',
  LINKEDIN = 'linkedin',
}

/**
 * Products – the 4 canonical product names that match the backend license model.
 * Every license has exactly one of these as its `product` field.
 */
enum Products {
  SAIA_RECRUITING = 'saia_recruiting',
  SAIA_SALES = 'saia_sales',
  SAIA_BUNDLE = 'saia_bundle',
  MOTIVE = 'motive',
  LEAD = 'lead',
}

enum ProductGroups {
  LEAD_BOOSTER = 'SAIA Sales',
  HR_BOOSTER = 'SAIA Recruiting',
}

enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

enum ImageTypes {
  MODERN_IMAGE = 'modernImage',
  CLASSIC_IMAGE = 'classicImage',
  EXTENDED_IMAGE = 'extendedImage',
}

enum AWTriggers {
  DomainChange = 'domainChange',
  Suggestion = 'suggestion',
  Manual = 'manual',
  ContactChanged = 'contactChanged',
  LoadText = 'loadText',
}

enum TooltipContentType {
  HIGHLIGHT = 'highlight',
  GRAMMAR_REPLACEMENT = 'grammar_replacement',
  PARAPHRASE = 'paraphrase',
}

enum Browser {
  MS_EDGE_OLD = 'msEdgeOld',
  MS_EDGE_CHROMIUM = 'msEdgeChromium',
  MS_IE = 'msInternetExplorer',
  CHROME = 'chrome',
  OPERA = 'opera',
  FIREFOX = 'firefox',
  SAFARI = 'safari',
  OTHER = 'other',
}

enum PlaceholderTokens {
  LINKEDIN_FORENAME = '{{linkedin.forename}}',
  LINKEDIN_SURNAME = '{{linkedin.surname}}',
  OWN_FORENAME = '{{user.forename}}',
  OWN_SURNAME = '{{user.surname}}',
  OWN_EMAIL = '{{user.email}}',
}

enum LoginPlatforms {
  MAIL = 'mail',
}

enum LinkedinProjectTypes {
  NORMAL = 'Linkedin Project',
  SALES_NAV = 'Linkedin Sales Navigator Project',
  RECRUITER = 'Linkedin Recruiter Project',
}

enum LinkedinTypes {
  LINKEDIN = 'linkedin',
  SALES_NAV = 'sales_navigator',
  RECRUITER = 'recruiter',
}

enum Genres {
  JOB_OFFER = 'job_offer',
  ACTIVE_SOURCING = 'active_sourcing',
  SALES_EMAIL = 'sales_email',
  CONNECTION_REQUEST = 'connection_request',
  MARKETING_NEWSLETTER = 'marketing_newsletter',
  SOCIAL_POST = 'social_post',
  SOCIAL_AD = 'social_ad',

  // new genres
  INVITATION = 'invitation',
  BLOG_POST = 'blogpost',
  BLOG_POST_TOC = 'blogpost_toc',
  LANDING_PAGE = 'landingpage',
  LANDING_PAGE_TOC = 'landingpage_toc',
  PRODUCT_DESCRIPTION = 'product_desc',
}

const MappedGenres = {
  default: AWTypes.TALENT,
  [Genres.JOB_OFFER]: AWTypes.TALENT,
  [Genres.SALES_EMAIL]: AWTypes.CUSTOMER,
  [Genres.CONNECTION_REQUEST]: AWTypes.LINKEDIN_MSG,
  [Genres.ACTIVE_SOURCING]: AWTypes.LINKEDIN_MSG,
  [Genres.MARKETING_NEWSLETTER]: AWTypes.CUSTOMER,
  [Genres.SOCIAL_AD]: AWTypes.LINKEDIN_MSG,
  [Genres.SOCIAL_POST]: AWTypes.LINKEDIN_MSG,

  // new genres
  [Genres.INVITATION]: AWTypes.CUSTOMER,
  [Genres.BLOG_POST]: AWTypes.BLOG,
  [Genres.BLOG_POST_TOC]: AWTypes.BLOG,
  [Genres.LANDING_PAGE]: AWTypes.BRAND, // since the website genre also uses brand domain
  [Genres.LANDING_PAGE_TOC]: AWTypes.BRAND, // since the website genre also uses brand domain
  [Genres.PRODUCT_DESCRIPTION]: AWTypes.ECOMMERCE,
};

enum SideBarSelection {
  ANALYSIS = 'analysis',
  DO = 'does',
  DONOT = 'donts',
  BOOSTER_WORDS = 'boosterWords',
  TEXT_OPTIMIZATION = 'textOptimization',
  EMAIL_OPTIMIZATION = 'emailOptimization',
  TEXT_GENERATION = 'textGeneration',
  TEMPLATES = 'optimizedTemplates',
  SETTINGS = 'settings',
}

enum ErrorMessages {
  USER_NOT_EXISTS = 'The user does not exist',
  USER_ALREADY_EXISTS = 'User already exists',
  EMAIL_ALREADY_EXISTS = '"email" already exists',
  WRONG_PASSWORD = 'Incorrect email or password',
  VALIDATION_ERROR = 'Validation Error',
  TOKEN_EXPIRED = 'Token expired',
  COMPANY_NAME_TOO_LONG = 'company name should not exceed 30 characters',
  TOKEN_EXPIRED_EXTERNAL = 'External token expired',
  LINKEDIN_ACCOUNT_NOT_FOUND = 'LinkedIn account entry not found!',
  ACCOUNT_OUT_OF_SYNC = 'Account out of sync! Login request initiated!',
  FUNNEL_CREDITS_EXHAUSTED = 'Cannot start funnel. Not enough credits to start the funnel!',
  NO_CO_PILOT_LICENSE_FOUND = 'No co-pilot license found!',
  CO_PILOT_LICENSE_EXPIRED = 'Your License has expired!',
  ACCOUNT_ALREADY_IN_QUEUE = 'Account already in queue!',
  UNABLE_TO_GENERATE_MESSAGE = 'getOptimizedGeneratedText Unable to generate a valid message text after', // only a part of the error message
  EMPTY_FLOW_NOT_SAVED = 'Empty flow was not saved!',
  WRONG_ACCOUNT_PARTIAL = 'exists to proceed with login! Please Register.',
  TOKEN_ALREADY_USED = 'token already used',
  EMAIL_VALIDATION_ERROR = '"email" must be a valid email',
  PASSWORD_LENGTH_VALIDATION_ERROR = '"password" length must be less than or equal to 128 characters long',
  FIRSTNAME_LENGTH_VALIDATION_ERROR = '"firstname" length must be less than or equal to 128 characters long',
  LASTNAME_LENGTH_VALIDATION_ERROR = '"lastname" length must be less than or equal to 128 characters long',
  CITY_NAME_LENGTH_VALIDATION_ERROR = '"address.city" length must be less than or equal to 128 characters long',
  INVITING_USER_LENGTH_VALIDATION_ERROR = '"invitingUser" length must be less than or equal to 128 characters long',
  PROFILE_ANALYSIS_IN_PROGRESS_PARTIAL = 'Profile analysis already in progress for funnel',
}

enum ProfileTypes {
  GLOBAL = 'global',
  TAILORED = 'tailored',
}

enum BaseProfileTypes {
  TARGET_GROUP = 'TargetGroup',
  CONTACT = 'Contact',
}

enum Roles {
  UN_AUTH = 'unauthorized',
  EXPIRED = 'expired',
  BASIC = 'basic',
  MANAGER = 'manager',
  AGENCY = 'agencyadmin',
  ADMIN = 'admin',
  OWNER = 'owner',
}

enum SessionStatus {
  START = 'start',
  MIDDLE = 'middle',
  END = 'end',
}

enum AnalysisStatus {
  NOT_CONNECTED = 'not-connected',
  PENDING = 'pending',
  SUSPENDED = 'suspended',
  DONE = 'done',
  EXPIRED = 'expired',
}

enum CookieErrors {
  EXPIRED = 'expired',
  SIGNED_OUT = 'signed-out',
  HOUR_LIMIT = '24-hour-limit',
  HOUR_LIMIT_SEARCH = '24-hour-search-limit',
  INVALID_COOKIES = 'invalid-cookies',
}

enum AnalysisSelection {
  PERSONALITY_TYPE = 'personalityType',
  DOS = 'does',
  DONTS = 'donts',
  BOOSTER_WORDS = 'boosterWords',
}

enum AnalysisSelectionNew {
  PERSONALITY_TYPE = 'personalityType',
  DOS_AND_DONTS = 'doesAndDonts',
  BOOSTER_WORDS = 'boosterWords',
}

enum ProfileBases {
  PERSON = 'person',
  EXACT = 'exactJobTitle',
  MATCHED = 'matchedJobTitle',
}

enum ZoomLevels {
  XL = 0.8, // BreakPoint 1537px
  CUSTOM_LG = 0.65, // BreakPoint 1300px
  LG = 0.55, // BreakPoint 1200px
  CUSTOM_MD = 0.5, // BreakPoint 1000px
  MD = 0.4,
}

export {
  AnalysisSelection,
  AnalysisSelectionNew,
  AnalysisStatus,
  AWTriggers,
  AWTypes,
  BaseProfileTypes,
  Browser,
  CookieErrors,
  ErrorMessages,
  Genres,
  ImageTypes,
  LinkedinProjectTypes,
  LinkedinTypes,
  LoginPlatforms,
  MappedGenres,
  PlaceholderTokens,
  ProductGroups,
  Products,
  ProfileBases,
  ProfileTypes,
  Roles,
  Routes,
  SessionStatus,
  SideBarSelection,
  SortDirection,
  TooltipContentType,
  ZoomLevels,
};
